import type { EntityType } from 'types/entityType';

export const ENTITY_TYPE: EntityType = 'boundary';

export const TEST_ID = 'boundaryMultiSelectPanelField';
